import { retrieve, create, deleteSavedBankAccount } from "api/profile";
/* Wrapper for all ajax activity for Profile creation */
class ProfileRepository {
    /**
     * Retrieve profile information from the API
     *
     * @method getProfile
     * @returns {axios.Promise}
     */
    getProfile() {
        return retrieve().then(({ data }) => data);
    }
    /**
     * Create profile information on the API
     *
     * @method createProfile
     * @param {Object} profile Information to send with request
     * @returns {axios.Promise}
     */
    createProfile(profile) {
        return create(profile).then(({ data }) => data);
    }
    /**
     * Update profile information on the API
     *
     * @method updatedProfile
     * @param {String} profile
     * @returns {axios.Promise}
     */
    updatedProfile(profile) {
        return create(profile).then(({ data }) => data);
    }
    deleteBank(id) {
        return deleteSavedBankAccount(id);
    }
}
export default new ProfileRepository();



// WEBPACK FOOTER //
// ./src/assets/scripts/domain/profile/ProfileRepository.ts